<template>
	<div style="min-height: 281px; height: 281px">
		<b-row>
			<b-col cols="6" xs="6" sm="4" md="4" lg="4" xl="4">
				<div class="sa-pianificazione-edit-container">
					<label for="">Numero Accessi:</label>
					<b-form-input type="number" v-model="numeroAccessi" @input="onInputNumeroAccessi"></b-form-input>
				</div>
			</b-col>
			<b-col cols="6" xs="6" sm="8" md="8" lg="8" xl="8">
				<div class="sa-pianificazione-edit-container">
					<label for="">Tipo Accesso:</label>
					<b-form-select v-model="tipoAccesso" :options="tipoAccessoOptions" value-field="value"
						text-field="text" @change="onInputTipoAccesso"></b-form-select>
				</div>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
	mixins: [UtilityMixin],
	components: {},
	data() {
		return {
			pianificazione: { params: { tipologia: null } },
			tipoAccesso: null,
			numeroAccessi: null,
			tipoAccessoOptions: [
				{ value: null, text: "- Selezionare il Tipo -" },
				// { value: "GIORNO", text: "Giorno" },
				{ value: "OCCASIONALE", text: "Occasionale" },
				{ value: "SETTIMANA", text: "Settimana" },
				{ value: "MESE", text: "Mese" },
			],
		};
	},
	created() { },
	mounted() {
		this.$emit("afterMounted"); //this.$emit("updatePianificazioneGiorniAlternati", me.pianificazione);
	},
	watch: {
		jsonDataSchedulazione: {
			handler() {
				this.aggiornaOrari();
			},
			deep: true,
		},
	},
	methods: {
		init(jsonData) {
			let me = this;
			me.jsonDataSchedulazione = jsonData;
		},
		aggiornaPianificazione() {
			console.log("aggiorna pianificazione");

			this.pianificazione.params.tipologia = this.tipoAccesso;
			this.pianificazione.giorni = this.numeroAccessi;
			this.$emit("updatePianificazioneAccessi", this.pianificazione);
		},
		setPianificazione(pianificazione) {
			console.log(pianificazione);
			let params = JSON.parse(pianificazione.params);
			this.tipoAccesso = params.tipologia;
			this.numeroAccessi = pianificazione.giorni;
		},
		onInputTipoAccesso() {
			this.aggiornaPianificazione();
		},
		onInputNumeroAccessi() {
			this.aggiornaPianificazione();
		},
	},
};
</script>

<style></style>
